import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import EmailIcon from "@mui/icons-material/Email";

const SendEmailConfirmDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{ sx: { borderRadius: 3, p: 0.5 } }}
    >
      <DialogTitle sx={{ pb: 1 }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              width: 34,
              height: 34,
              borderRadius: "50%",
              background: "rgba(13,43,94,0.1)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <EmailIcon sx={{ color: "#0d2b5e", fontSize: 18 }} />
          </Box>
          <Typography sx={{ fontWeight: 700, fontSize: "0.95rem", color: "#0b1e3d" }}>
            Send Email
          </Typography>
        </Box>
      </DialogTitle>

      <DialogContent sx={{ pt: 0, pb: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Are you sure you want to send the email? This will notify the recipient immediately.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.5, gap: 1 }}>
        <Button variant="outlined" size="small" onClick={onClose} sx={{ minWidth: 80 }}>
          Cancel
        </Button>
        <Button variant="contained" size="small" onClick={onConfirm} sx={{ minWidth: 100 }}>
          Send Email
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SendEmailConfirmDialog;
